<template>
  <div class="price-card">
    <div class="tip" v-if=" $store.state.plat_id!='120' || type!='live'">
            <!-- is_vip_flat 判断是否会员商品 0不是 1是  is_free 判断是否限免 2是  1不是-->
            <img :src="$free" v-if="cardData.is_free==2"/>
            <img :src="$vip" v-else-if="cardData.is_vip_flat==1"/>
            <img :src="$noVip" v-else>
    </div>
    <van-image class="price-cover" fit="cover" 
    :error-icon="$placeImg"
    :loading-icon="$placeImg"
     :src="cardData.cover_mobile || cardData.img_url" alt=""></van-image>
    <div class="price-msg">
      <div class="price-name ellipsis_two">{{ cardData.name }}</div>
      <!-- <div class="price-des ellipsis_two">{{ cardData.description }}</div> -->
      <div class="yingyouPrice"  v-if="plat!=120 && type!='live' && !$store.state.plat.priceHide" >
        ¥ {{ cardData.price }}
      </div>
      <div class="btn">立即学习</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: {},
      required: true,
      validator: function (value) {
        return value;
      },
    },
    type: {
      type:String,
      default : ''
    }
  },
  computed: {
    plat() {
      return this.$store.state.plat_id
    },
  },
  data() {
    return {};
  },
  methods: {
    
  },
};
</script>

<style scoped lang="scss">
.price-card {
  width: 100%;
  margin-bottom: 32px;
  box-sizing: border-box;
  position: relative;
  
  overflow: hidden;
  // box-shadow: 0 0 10px 2px rgba($color: #000000, $alpha: 0.12);
  background-color: #fff;
  .tip{
    position: absolute;
    top:0;
    left:0;
    z-index: 1;
    img{
      width: 78px;
      height: 35px;
    }
  }
}
::v-deep .van-image__error,::v-deep .van-image__loading{
  position: static;
}
.price-card:last-of-type {
  /* margin-bottom: 0; */
}

.price-cover {
  width: 100%;
  // height: calc(100% * 9/16);
  display: block;
  overflow: hidden;
  border-radius: 12px;
}

.price-msg {
  width: 100%;
  padding: 0 10px;
}

.price-name {
  font-size: 32px;
  color: #333;
  font-weight: 600;
  width: 100%;
  margin-top: 24px;
  margin-bottom: 42px;
  height: 82px;
}

.price-des {
  font-size: 26px;  
  color: #666;
  font-weight: 400;
  width: 100%;
  margin-bottom: 20px;
  height: 70px;
}
.btn{
  width: 100%;
  height: 56px;
  border-radius: 28px;
  text-align: center;
  line-height: 56px;
  background-color: #F5F7FA;
  color: #144094;
  margin-bottom: 20px;
}
.yingyouPrice {
  font-size: 24px;
  color: #F08E00;
  font-weight: 500;
}
</style>>
